import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import withAdminLayout from '../../layout/withAdminLayout';
import { Spin } from 'antd';

const Dashboard       = lazy(() => import('../../container/vas/Index'));

function VASRoutes() {
    return (
        <Suspense
            fallback={
                <div className="spin">
                    <Spin />
                </div>  
            }
        >
            <Routes>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
        </Suspense>
    );
}

export default withAdminLayout(VASRoutes);
